import { useCallback } from "react";
import { useMDSSession } from "@/mds/components/sessions/session-context/mds-session-context";

export const useReasoningGroupUi = (groupId: string) => {
  const { reasoningGroups, toggleReasoningGroup, autoCollapseReasoningGroup } = useMDSSession();

  const state = reasoningGroups[groupId] ?? { isCollapsed: true, userToggled: false };

  const toggle = useCallback(() => {
    toggleReasoningGroup(groupId);
  }, [groupId, toggleReasoningGroup]);

  const autoCollapse = useCallback(() => {
    autoCollapseReasoningGroup(groupId);
  }, [groupId, autoCollapseReasoningGroup]);

  return { ...state, toggle, autoCollapse };
};
